exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donutchart-track{fill:transparent;stroke:#dae2e5;stroke-width:26}.donutchart-indicator{fill:transparent;stroke:#009688;stroke-width:26;stroke-dasharray:0 10000;-webkit-transition:all 2s linear;-o-transition:all 2s linear;transition:all 2s linear}.donutchart{margin:0 auto;border-radius:50%;display:block}.donutchart-text{fill:#607580}.donutchart-text-val{font-size:4em}.donutchart-text-percent{font-size:2em}.donutchart-text-label{font-size:1.2em}.donut-container{text-align:center;margin-top:30px;margin-bottom:30px}.donutchart-line{stroke:#c8c8c8;stroke-width:1}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/donut.scss
// module id = 1541
// module chunks = 0